"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminPayment = exports.className = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../hooks/useForm");
const Sub_1 = require("../../Page/Title/Sub");
const AccountBalance_1 = require("./components/AccountBalance");
const ExistingPayments_1 = require("./components/ExistingPayments");
const PriceToPay_1 = require("./components/PriceToPay");
const SelectPayment_1 = require("./components/SelectPayment");
const SpecificPriceAttention_1 = require("./components/SpecificPriceAttention");
const TotalCalculatedPrice_1 = require("./components/TotalCalculatedPrice");
const hidePrice_1 = require("./editors/hidePrice");
const specificPrice_1 = require("./editors/specificPrice");
const updateFee_1 = require("./editors/updateFee");
require("./index.scss");
exports.className = 'admin-payment';
const descriptor = {
    specificPrice: useForm_1.allDescriptors.number({
        restrictions: {
            roundedMoney: true,
            positiveNumber: true,
        },
    }),
    hidePrice: useForm_1.allDescriptors.boolean(),
    updateFee: useForm_1.allDescriptors.number({
        restrictions: {
            roundedMoney: true,
            positiveNumber: true,
            withoutZeroNumber: true,
        },
    }),
};
const AdminPayment = (props) => {
    const { info, existingPayments, paymentTermsConfig, formConfig: config, data: propsValues, changeData: onChange, validator: validateForm, onSubmit, } = props;
    const { fields, validateAll, isValid } = (0, useForm_1.useForm)({ descriptor, config, propsValues, onChange, validateForm });
    const submit = (0, react_1.useCallback)((paymentType) => {
        if (!validateAll())
            return;
        onSubmit(paymentType);
    }, [onSubmit, validateAll]);
    return (react_1.default.createElement("div", { className: exports.className },
        react_1.default.createElement("div", { className: `${exports.className}__header` },
            react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'money', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:title', defaultMessage: 'Payment' }), modificators: ['margin-bottom-sm'] })),
        react_1.default.createElement("div", { className: `${exports.className}__form` },
            react_1.default.createElement("div", { className: `${exports.className}__row` },
                react_1.default.createElement(TotalCalculatedPrice_1.TotalCalculatedPrice, { value: info.totalCalculated }),
                react_1.default.createElement(updateFee_1.UpdateFeeEditor, { field: fields.updateFee }),
                react_1.default.createElement(hidePrice_1.HidePriceEditor, { field: fields.hidePrice })),
            react_1.default.createElement("div", { className: `${exports.className}__row` },
                react_1.default.createElement(specificPrice_1.SpecificPriceEditor, { field: fields.specificPrice }),
                react_1.default.createElement(ExistingPayments_1.ExistingPayments, { existingPayments: existingPayments, hidden: existingPayments.length === 0 }),
                react_1.default.createElement(AccountBalance_1.AccountBalance, { value: info.debit }),
                react_1.default.createElement(PriceToPay_1.PriceToPay, { value: info.priceToPay })),
            react_1.default.createElement(SpecificPriceAttention_1.SpecificPriceAttention, { totalOnOpenCalculated: fields.specificPrice.input ? info.totalOnOpenCalculated : undefined, totalCalculated: info.totalCalculated })),
        react_1.default.createElement(SelectPayment_1.SelectPayment, { select: submit, paymentTermsConfig: paymentTermsConfig, disabled: !isValid })));
};
exports.AdminPayment = AdminPayment;
//# sourceMappingURL=index.js.map